import type { Person } from "features/people/data/types";
import type { StatusRestriction } from "features/restrictions/data/types";
import {
  getRestrictionByType,
  hasRestriction,
} from "features/restrictions/utils";

import { useDataQuery } from "./useData";

type UserStatus = {
  isLoggedIn?: boolean;
  isEditor?: boolean;
  isContributor?: boolean;
  isAdmin?: boolean;
  username?: string | null;
  userId?: number | null;
  person?: Person | null;
  canPublishAsCollective?: boolean;
  isContentEditor?: boolean;
  isModerator?: boolean;
  restrictions?: StatusRestriction[];
};

export const useUser = () => {
  const userData = useDataQuery<UserStatus>(`user/status/`);

  const restrictions = userData?.restrictions ?? [];

  return {
    isLoggedIn: userData?.isLoggedIn ?? false,
    isEditor: userData?.isEditor ?? false,
    isContributor: userData?.isContributor ?? false,
    isAdmin: userData?.isAdmin ?? false,
    username: userData?.username ?? null,
    userId: userData?.userId ?? null,
    person: userData?.person ?? null,
    personId: userData?.person?.id ?? null,
    canPublishAsCollective: userData?.canPublishAsCollective ?? false,
    isContentEditor: userData?.isContentEditor ?? false,
    isModerator: userData?.isModerator ?? false,
    restrictions,
    isBannedFromComments: hasRestriction(restrictions, "ban_comment"),
    isBannedFromEditing: hasRestriction(restrictions, "ban_edit"),
    isBannedFromPublishing: hasRestriction(restrictions, "ban_publish"),
    isBlocked: hasRestriction(restrictions, "block"),
    isBlockedResriction: getRestrictionByType(restrictions, "block"),
  };
};
